import invoke from 'lodash/invoke';

export function getCoverageVarValue(option?: string | number | boolean | null) {
  if (option === undefined) {
    return 'null';
  }
  return invoke(option, 'toString') || JSON.stringify(option);
}
